import PropTypes from 'prop-types'
import { Element } from '../../../../common/html/element'
import { TextEllipsisStaticLine } from '../../../../common/textEllipsis/TextEllipsisStaticLine'

export const TextTwoLine = ({ text }) => {
  return (
    <Element className="cursorPointer breakWord">
      <TextEllipsisStaticLine
        text={text}
        isI18n={false}
        tooltipMaxWidthByContent
        tooltipStyle={{ minWidth: 200 }}
      />
    </Element>
  )
}

TextTwoLine.propTypes = {
  text: PropTypes.any,
}
TextTwoLine.defaultProps = {
  text: '',
}
